import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
} from "@mui/material";
import { MdEdit, MdDelete, MdCheckCircle } from "react-icons/md";
import { usePaginasWebContext } from "../paginas-web-context";

export function PaginasWebTable() {
  const navigate = useNavigate();

  const { paginasWeb, deletePaginaWeb, verifyPaginaWeb } =
    usePaginasWebContext();

  return (
    <Paper
      sx={{ padding: 1 }}
      className="animate__animated animate__fadeIn"
      variant="outlined"
    >
      <Stack>
        <Stack justifyContent="space-between" direction="row" padding={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h6">Direcciones de página web</Typography>
          </Stack>

          {/* <Button
            variant="contained"
            color="success"
            size="small"
            fullWidth={false}
            onClick={() => navigate("add")}
          >
            Agregar
          </Button> */}
        </Stack>

        {!!paginasWeb.length ? (
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {["#", "Dirección de página web", "Estado", "Opciones"].map(
                  (label, i) => (
                    <TableCell key={i}>{label}</TableCell>
                  )
                )}
              </TableRow>
            </TableHead>

            <TableBody>
              {paginasWeb.map((pagina, index) => (
                <TableRow key={pagina.pagina_web_id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography variant="body2">
                        <a
                          href={`https://${pagina.pagina_web_url}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {pagina.pagina_web_url}
                        </a>
                      </Typography>

                      {!!pagina.pagina_web_principal && (
                        <Chip
                          label="Principal"
                          size="small"
                          color="success"
                          variant="outlined"
                        />
                      )}
                    </Stack>
                  </TableCell>

                  {/* <TableCell>
                    <Chip
                      label={
                        !!pagina.pagina_web_verificada
                          ? "Verificada"
                          : "Pendiente"
                      }
                      color={
                        !!pagina.pagina_web_verificada ? "success" : "warning"
                      }
                      variant="outlined"
                      size="small"
                    />
                  </TableCell>

                  <TableCell align="center">
                    {!pagina.pagina_web_verificada ? (
                      <Stack direction="row" justifyContent="center">
                        <Tooltip title="Verificar">
                          <IconButton
                            color="success"
                            size="small"
                            onClick={async () =>
                              await verifyPaginaWeb({
                                paginaWebId: pagina.pagina_web_id,
                              })
                            }
                          >
                            <MdCheckCircle />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Modificar">
                          <IconButton
                            color="warning"
                            size="small"
                            onClick={() =>
                              navigate(`${pagina.pagina_web_id}/edit`, {
                                replace: true,
                              })
                            }
                          >
                            <MdEdit />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Eliminar">
                          <IconButton
                            color="error"
                            size="small"
                            onClick={async () => {
                              await deletePaginaWeb({
                                paginaWebId: pagina.pagina_web_id,
                              });
                            }}
                          >
                            <MdDelete />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    ) : (
                      "-"
                    )}
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography align="center" variant="overline">
            Sin direcciones de página web
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
